import _ from 'lodash'
import React, { useState } from 'react'
import PasswordChecklist from 'react-password-checklist'
import Input from '@vero/ui-components/components/input.jsx'
import IconShow from '@vero/ui-components/icons/show.jsx'
import IconHide from '@vero/ui-components/icons/hide.jsx'

export default function ({ name, value, minLength = 8, ...props }) {
  const [valid, setValid] = useState(false)
  const [hidden, setHidden] = useState(true)

  const iconClassName = 'h-6 w-6 hover:opacity-50 cursor-pointer'
  const iconOnClick = () => setHidden(!hidden)

  return (
    <>
      <Input
        type={hidden ? 'password' : 'text'}
        name={name || 'password'}
        autoComplete='new-password'
        value={value}
        minLength={minLength}
        pattern={valid ? '.+' : `${_.random(0, 999999999999)}.+`}
        {...props}
      >
        {hidden ? <IconShow className={iconClassName} onClick={iconOnClick} /> : <IconHide className={iconClassName} onClick={iconOnClick} />}
      </Input>

      <PasswordChecklist
        rules={['minLength', 'number', 'capitalAndLowercase', 'noSpaces']}
        minLength={minLength}
        value={value}
        onChange={isValid => setValid(isValid)}
        iconSize={16}
      />
    </>
  )
}
